<div class="page-title flex justify-between items-center">
  <div class="title move-left" style="--order:2">
    <span class="">{{ title }}</span>
  </div>

  <ng-container *ngIf="useBackButton">
    <div class="bg-gradient2 move-left cursor-pointer rounded-md p-2" matTooltip="Back">
      <span (click)="goBack()">
        <strong class="flex justify-center items-center">
          <mat-icon svgIcon="back"></mat-icon>
        </strong>
      </span>
    </div>
  </ng-container>

  <ng-container *ngIf="useRouterButton">
    <div class="back-button content-item" style="--order:2">
      <button class="blue-btn tfra-button" routerLink="{{ routerUrl }}">
        {{ routerUrlName }}
      </button>
    </div>
  </ng-container>
</div>
